import { render, staticRenderFns } from "./saintbrand-features-grid.vue?vue&type=template&id=ea25b2d6&scoped=true&"
import script from "./saintbrand-features-grid.vue?vue&type=script&lang=js&"
export * from "./saintbrand-features-grid.vue?vue&type=script&lang=js&"
import style0 from "./saintbrand-features-grid.vue?vue&type=style&index=0&id=ea25b2d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea25b2d6",
  null
  
)

export default component.exports